exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/angular/DineroAgil/src/app/pages/credit-list/credit-list.component.css
// module id = ../../../../../src/app/pages/credit-list/credit-list.component.css
// module chunks = main